import React, { useEffect, useState } from 'react';
import MasterPage from 'components/MasterPage';
import { Row, Container, Col, Card, Alert } from 'react-bootstrap';
import { WidgetsOutlined } from '@material-ui/icons';
import masterAgentService from '../../services/master-agent-request';
import TableMasterAgent from 'components/TableMasterAgent';
import { useCompany, useUser } from 'models';

export default function MyComissions() {
  const user = useUser()
  const { company } = useCompany();


  const [filters, setFilters] = useState(!company ? {} : { company: company.document })
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [filtersList, setFiltersList] = useState({
    'Condição': {
      width: 2,
      type: 'select',
      options: {},
      comparator: 'equal'
    },
    'Mês': {
      width: 1,
      ref: "Período de Referência",
      type: 'select',
      comparator: 'like',
      options: {}
    },
    'Ano': {
      width: 1,
      ref: "Período de Referência",
      type: 'select',
      comparator: 'like',
      options: {}
    }
  });

  useEffect(() => {
    const get = async () => {
      setIsLoading(true)
      const response = await masterAgentService.getAllComissions({ ...filters, format: 'list' })
      const { collection, columns } = response.data
      for (let item of collection) {
        let aux = filtersList
        if (item['Condição']) {
          aux['Condição'].options[item['Condição']] = item['Condição']
          setFiltersList(aux)
        }

        //if (item['Período de Referência'] != "") {
          let [month, year] = item['Período de Referência'].split('/')
          month = month == "" ? 
            "--" : 
            month.length == 1 ?
             '0' +month :
              month 
          
          year = !year ? "--" : year
          aux['Mês'].options[month] = month
          aux['Ano'].options[year] = year
          setFiltersList(aux)
        //}
      }
      
      setColumns(columns)
      setData(collection)
      setIsLoading(false)
    }
    get()
  }, []);

  return (
    <Container fluid>
      <Row className="col-12 mt-4 row">
        <WidgetsOutlined className="icon-title" />
        <h5 className="title-dashboard">Minhas Comissões</h5>
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 col-12 mb-5">
          <Row>
            <Col md="12">
              <Alert variant="warning">
                <h6>
                  <b>IMPORTANTE:</b> Os valores informados podem sofrer alterações sem aviso prévio. 
                  Atente-se à condição de cada comissão. Somente <b>APTAS</b> estão liberadas para pagamento. 
                  As comissões em <b>POTENCIAL</b> não são definitivas e poderão ser canceladas, não havendo garantia de seu recebimento. 
                  Para solicitar sua comissão acesse a área restrita no site da Scansource em <a target="_blank" href="https://www.scansource.com.br">https://www.scansource.com.br</a>
                </h6>
              </Alert>
            </Col>
          </Row>
            <TableMasterAgent
              isLoading={isLoading}
              exportFile={true}
              collection={data}
              columns={columns}
              filtersList={filtersList}
              btnAddProps={{
                url: '/master-agent/new-comission',
                label: 'Contestação de Comissão'
              }}
              fileExportName={'MA-Comissões'}
            />
        </Card.Body>
      </Row>
    </Container>
  );
}
